export default {
  'edit.title': 'Módulos e permissões',

  'modules.asset.title': 'Ativo',
  'modules.asset.description': 'Controle os ativos para atendimento do time em campo',
  'modules.asset.fields.editAndImport': 'Cadastro dos meus ativos',
  'modules.asset.fields.listAndExport': 'Visualizar e exportar os meus ativos',
  'modules.asset.fields.delete': 'Deletar os meus ativos',

  'modules.dashboard.title': 'Métricas',
  'modules.dashboard.description': 'Insights e dashboard para controle gerencial',
  'modules.dashboard.fields.dashboard': 'Ter visão do meu time de campo com o dashboard',
  'modules.dashboard.fields.complianceTab': 'Habilitar aba de eficiência no dashboard',

  'modules.user.title': 'Usuário',
  'modules.user.description': 'Controle os seus usuários Btime',
  'modules.user.fields.editAndImport': 'Cadastro dos meus usuários',
  'modules.user.fields.listAndExport': 'Visualizar e exportar os meus usuários',
  'modules.user.fields.delete': 'Deletar os meus usuários',
  'modules.user.fields.createNewUsersForClients': 'Permitir que eu crie usuários para meus clientes',
  'modules.user.fields.createNewUsersForThirdParty':
    'Permitir que eu crie usuários para meus colaboradores terceirizados',

  'modules.customer.title': 'Cliente',
  'modules.customer.description': 'Controle os clientes para atendimento do time em campo',
  'modules.customer.fields.editAndImport': 'Cadastro dos meus clientes',
  'modules.customer.fields.listAndExport': 'Visualizar e exportar os meus clientes',
  'modules.customer.fields.delete': 'Deletar os meus clientes',
  'modules.customer.fields.controlSegments': 'Manter segmentação de clientes',
  'modules.customer.fields.controlWaller': 'Manter carteira de clientes',
  'modules.customer.fields.controlRequest': 'Ativar campo adicional de solicitante nas ordens de serviço',

  'modules.checkList.title': 'Questionário',
  'modules.checkList.description': 'Crie formulários e padronize seus checklists',
  'modules.checkList.fields.editAndImport': 'Cadastro dos meus questionários',
  'modules.checkList.fields.listAndExport': 'Visualizar e exportar os questionários',
  'modules.checkList.fields.delete': 'Deletar os meus questionários',
  'modules.checkList.fields.addQuestions': 'Permitir vincular perguntas de um questionário',

  'modules.serviceOrder.title': 'Atividade',
  'modules.serviceOrder.description': 'Controle os processos de atendimento',
  'modules.serviceOrder.fields.editAndImport': 'Cadastro das minhas ordens de serviço',
  'modules.serviceOrder.fields.listAndExport': 'Visualizar e exportar ordens de serviço',
  'modules.serviceOrder.fields.delete': 'Deletar as minhas ordens de serviço',
  'modules.serviceOrder.fields.replyRequester': 'Responder solicitantes das atividades',
  'modules.serviceOrder.fields.ownedOnly': 'Visualizar somente minhas ordens de serviço',
  'modules.serviceOrder.fields.newSOWithUser': 'Criar atividades para qualquer usuário no mobile',
  'modules.serviceOrder.fields.validateAndApprove': 'Validar e aprovar o atendimento do meu time de campo',
  'modules.serviceOrder.fields.transport': 'Desejo ativar informações de transporte para atendimento',
  'modules.serviceOrder.fields.priority': 'Desejo ativar priorização de atendimento do meu time de campo',
  'modules.serviceOrder.fields.actionPlan': 'Desejo ativar tratativa de não conformidade com 5W2H',
  'modules.serviceOrder.fields.fastSO': 'Desejo ativar a criação de ordens de serviço rápidas para meu time de campo',
  'modules.serviceOrder.fields.acceptView': 'Esconder tela de aceite no app',
  'modules.serviceOrder.fields.executionView': 'Esconder confirmação da execução no app',
  'modules.serviceOrder.fields.geofenceRadius': 'Desejo ativar cerca digital para meu time de campo',
  'modules.serviceOrder.fields.review': 'Desejo ativar a configuração de revisão das minhas atividades',
  'modules.serviceOrder.fields.retroactive': 'Desejo ativar a criação de atividades retroativas',
  'modules.serviceOrder.fields.publicExecution': 'Permite enviar link publico de execução de atividades',

  'modules.recurrence.title': 'Recorrencias',
  'modules.recurrence.description': '-',

  'modules.refund.title': 'Reembolsos',
  'modules.refund.description': 'Controle os gastos do seu time de campo',
  'modules.refund.fields.editAndImport': 'Cadastro de reembolsos',
  'modules.refund.fields.listAndExport': 'Visualizar e exportar os reembolsos',
  'modules.refund.fields.delete': 'Deletar os reembolsos',
  'modules.refund.fields.approve': 'Aprovar reembolsos cadastrados',

  'modules.map.title': 'Mapa',
  'modules.map.description': 'Visualização em mapa do seu time e clientes',

  'modules.fleet.title': 'Frota',
  'modules.fleer.description': '-',

  'modules.skill.title': 'Skill',
  'modules.skill.description': 'Controle as competências de seu time em campo',

  'modules.calendar.title': 'Calendário',
  'modules.calendar.description': 'Controle os agendamentos de serviço',

  'modules.userCustomerRelation.title': 'Relacionamento de cliente',
  'modules.userCustomerRelation.description': '-',

  'modules.workflow.title': 'Workflow',
  'modules.workflow.description': '-',

  'modules.thirdParty.title': 'Terceiros',
  'modules.thirdParty.description': '-',

  'modules.integration.title': 'Integrações',
  'modules.integration.description': 'Integre a Btime com outros sistemas',
  'modules.integration.fields.crud': 'Criar webhooks para integrar meus sistemas',
  'modules.integration.fields.api': 'Utilizar API aberta da Btime',
  'modules.integration.fields.delete': 'Deletar meus webhooks',

  'modules.segment.title': 'Segmentos',
  'modules.segment.description': 'Controle dos segmentos',
  'modules.segment.fields.editAndImport': 'Cadastro dos meus segmentos',
  'modules.segment.fields.listAndExport': 'Visualizar e exportar os meus segmentos',
  'modules.segment.fields.delete': 'Deletar os meus segemntos',

  'modules.place.title': 'Locais',
  'modules.place.description': 'Controle dos cadastros de locais',
  'modules.place.fields.editAndImport': 'Cadastro dos meus locais',
  'modules.place.fields.listAndExport': 'Visualizar e exportar os meus locais',
  'modules.place.fields.delete': 'Deletar os meus locais',
  'modules.place.fields.placeLevel': 'Cadastro de níveis de locais',

  'modules.person.title': 'Pessoas',
  'modules.person.description': 'Controle dos cadastros de pessoas',
  'modules.person.fields.editAndImport': 'Cadastro das minhas pessoas',
  'modules.person.fields.listAndExport': 'Visualizar e exportar as minhas pessoas',
  'modules.person.fields.delete': 'Deletar as minhas pessoas',
  'modules.person.fields.placeLevel': 'Cadastro de níveis de pessoas',

  'modules.fleet.title': 'Frota',
  'modules.fleet.description': 'Controle dos cadastros de Frotas',
  'modules.fleet.fields.editAndImport': 'Cadastro das minhas frotas',
  'modules.fleet.fields.listAndExport': 'Visualizar e exportar as minhas frotas',
  'modules.fleet.fields.delete': 'Deletar as minhas frotas',
  'modules.fleet.fields.placeLevel': 'Cadastro de níveis de Frotas',

  'modules.form.title': 'Formulários',
  'modules.form.description': 'Controle dos cadastros e envio de formulários',
  'modules.form.fields.editAndImport': 'Cadastro dos meus formulários',
  'modules.form.fields.listAndExport': 'Visualizar e exportar os meus formulários',
  'modules.form.fields.delete': 'Deletar os meus formulários',
  'modules.form.fields.share': 'Compartilhar e enviar os meus formulários',

  'modules.template.title': 'Templates de documentos',
  'modules.template.description': 'Controle dos cadastros de templates',
  'modules.template.fields.edit': 'Cadastro dos meus templates',

  'modules.templateRecord.title': 'Geração documentos',
  'modules.templateRecord.description': 'Controle dos cadastros de documentos',
  'modules.templateRecord.fields.edit': 'Gerar PDFs',

  'modules.qrcode.title': 'QR Codes',
  'modules.qrcode.description': 'Gerenciamento de QR Codes',

  'modules.nonCompliance.title': 'Não conformidade',
  'modules.nonCompliance.description': 'Visualizar todas as não conformidades'
}
